import { precarregar } from "./api.js";

/**
 * O que cada destino do menu carrega assim que o ponteiro encosta nele.
 *
 * **Só leitura, e só a consulta que a tela faz primeiro.** O objetivo é que a
 * tela abra com o dado já a caminho, não pré-buscar o app inteiro: cada entrada
 * aqui é uma requisição que o navegador vai disparar por passar o mouse, e uma
 * lista generosa transformaria hesitação em tráfego.
 *
 * O que torna isso útil é a janela de dois segundos de `api.ts`: a promessa em
 * voo é reaproveitada pelo `pedir` da tela que abre em seguida, em vez de virar
 * uma segunda viagem.
 *
 * Destino que não está aqui simplesmente não pré-carrega. É o caso de `/acervo`
 * e `/ajustes`, cuja primeira consulta depende da aba escolhida.
 */
const POR_DESTINO: Record<string, (() => void) | undefined> = {
  "/": () => precarregar("home.painel"),
  "/estudar": () => {
    precarregar("estudo.ver");
    precarregar("estudo.opcoes");
  },
  "/revisar": () => precarregar("revisao.painel"),
  "/caderno": () => {
    precarregar("categoria.listar");
  },
  /*
   * `estatistica.painel` fica de fora: ela é POST com corpo — leitura
   * parametrizada, na forma que o contrato já usa —, e o pré-carregamento só
   * vale para GET. Pré-carregar uma rota com corpo significaria adivinhar a
   * janela que a tela vai pedir, e adivinhar errado é uma viagem a mais.
   */
  "/simulado": () => precarregar("simulado.painel"),
};

export function precarregarDestino(para: string): void {
  POR_DESTINO[para]?.();
}
